export class MenuModel  {
    id:number;
    title: string;
    routeName:string;
    parentId:number;
    sequence:number;   
    isActive:boolean; 
    navClass:string;
}

export class DisplayMenuModel{
    id:number;
    title: string;
    parentId:number;
    sequence:number; 
    routeName:string;  
    isActive:boolean; 
    subMenus:MenuModel[];
    haveSubMenu:boolean;
    navClass:string;
}
